import _ from "es-toolkit/compat";
import {
  Environment,
  FetchFunction,
  Network,
  RecordSource,
  Store,
} from "relay-runtime";

import { baiFetch } from "./hooks/auth";

// eslint-disable-next-line
//@ts-ignore
const fetchRelay: FetchFunction = async (
  params,
  variables,
  cacheConfig,
  uploadables
) => {
  // console.debug(
  //   `fetching query ${params.name} with ${JSON.stringify(variables)} ${
  //     params.text
  //   }`
  // );
  // console.log(cacheConfig, uploadables);

  // default headers
  // TODO: 필요시 현재 사용자 sessionToken headers 지정
  const headers: {
    [key: string]: string;
  } = {};

  let body: any;
  if (uploadables) {
    headers["Content-Type"] = "multipart/form-data";
    body = body = new FormData();
    body.append(
      "operations",
      JSON.stringify({
        query: params.text,
        variables,
      })
    );

    const keys = _.keys(uploadables);
    const map = _.reduce(
      keys,
      (result, v, idx) => {
        result[idx.toString()] = [v];
        return result;
      },
      {} as {
        [key: string]: string[];
      }
    );
    body.append("map", JSON.stringify(map));
    _.each(keys, (v, idx) => {
      body.append(idx.toString(), uploadables[v]);
    });
  } else {
    body = JSON.stringify({
      query: params.text,
      variables,
    });
  }

  return baiFetch("/pipeline/graphql/", {
    method: "POST",
    headers,
    body: body,
  })
    .then((res) => res.json())
    .then(
      (response: {
        data: any;
        errors?: {
          extensions?: {
            code: "authentication_failed" | "not_authenticated" | string;
          };
          message: string;
        }[];
      }) => {
        if (
          response.errors?.find(
            (e) =>
              e.extensions?.code === "authentication_failed" ||
              e.extensions?.code === "not_authenticated"
          )
        ) {
          throw new Error("InvalidSessionToken");
        }
        return response;
      }
    );
};

// Export a singleton instance of Relay Environment
// configured with our network function:
export const createRelayEnvironment = () => {
  return new Environment({
    network: Network.create(fetchRelay),
    store: new Store(new RecordSource()),
    // handlerProvider: null
  });
};
